import type { AccommodationReviews } from './types';

interface AccommodationReviewResponse {
  avg_rating_overall: number;
  avg_rating_area: number;
  avg_rating_comfort: number;
  avg_rating_value: number;
  avg_rating_cleanliness: number;
  reviews: {
    id: number;
    nps: number;
    comment: {
      id: number;
      user_name: string;
      comment: string;
      original_comment: string | null;
      translated: boolean;
      comment_date: string;
    };
  }[];
  pagination: {
    total_entries: number;
    current_page: number;
    total_pages: number;
    offset: number;
  };
}

// eslint-disable-next-line import/prefer-default-export
export async function fetchAccommodationReviews(
  locale: string,
  accommodationId: number,
  page: number,
): Promise<AccommodationReviews> {
  const path = `/api/internal/${locale}/accommodations/${encodeURIComponent(
    accommodationId,
  )}/reviews?page=${encodeURIComponent(page)}`;
  const response = await fetch(path, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('no reviews found');
  }

  const json = (await response.json()) as AccommodationReviewResponse;
  return {
    avgRatingOverall: json.avg_rating_overall,
    avgRatingArea: json.avg_rating_area,
    avgRatingComfort: json.avg_rating_comfort,
    avgRatingValue: json.avg_rating_value,
    avgRatingCleanliness: json.avg_rating_cleanliness,
    reviews: json.reviews.map((review) => ({
      id: review.id,
      nps: review.nps,
      comment: {
        id: review.comment.id,
        userName: review.comment.user_name,
        comment: review.comment.comment,
        originalComment: review.comment.original_comment,
        translated: review.comment.translated,
        commentDate: new Date(Date.parse(review.comment.comment_date)),
      },
    })),
    pagination: {
      totalEntries: json.pagination.total_entries,
      currentPage: json.pagination.current_page,
      totalPages: json.pagination.total_pages,
      offset: json.pagination.offset,
    },
  };
}
